import { Flex, Text } from "../../components";
import { useCallback, useEffect } from "react";
import AddLocation from "../addLocation";
import { useApp } from "../../hooks";
import { EnvironmentTwoTone } from "@ant-design/icons";

let activeLocationModal: { destroy: () => void } | null = null;

const closeLocationModal = () => {
  activeLocationModal?.destroy();
  activeLocationModal = null;
};

const UserRegion = ({ className = "" }: { className?: string }) => {
  const { location, isReady, modal, isPickup } = useApp();
  const isComplete = isPickup
    ? !!(location?.city && location?.branch)
    : !!(location?.city && location?.area);

  const openLocation = useCallback(
    (canClose: boolean) => {
      if (activeLocationModal) return;
      activeLocationModal = modal.show({
        title: "Please select your location",
        closable: canClose,
        onClose: () => {
          activeLocationModal = null;
        },
        content: <AddLocation onSave={async () => closeLocationModal()} />,
      });
    },
    [modal],
  );

  useEffect(() => {
    if (!isReady || isComplete) return;
    openLocation(false);
  }, [isReady, isComplete, openLocation]);

  const selectedLocation = isPickup
    ? [location?.branch?.name, location?.city?.name].filter(Boolean).join(", ")
    : location?.city && location?.area
      ? `${location.area.name}, ${location.city.name}`
      : "";

  return (
    <div className={className}>
      {isComplete && (
        <Flex
          gap={"1rem"}
          align="center"
          className="cursor-pointer"
          onClick={() => openLocation(true)}
        >
          <EnvironmentTwoTone
            className="shrink-0 text-[2rem] leading-none"
            twoToneColor="#FFFFFF"
          />
          <div className="flex flex-col justify-center leading-none">
            <Text
              level={5}
              weight={"700"}
              type="tertiary"
              children={selectedLocation}
            />
          </div>
        </Flex>
      )}
    </div>
  );
};

export default UserRegion;
